import { r as registerInstance, c as createEvent, h, H as Host } from './index-5faac9d7.js';

const pesRadioCss = ":host{box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}:host(.radio--column){display:flex;flex-direction:column}";

const PesRadio = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pesRadioChange = createEvent(this, "pesRadioChange", 1);
    this.items = [];
    this.groupId = undefined;
    this.selectedValue = undefined;
  }
  onChange(e) {
    this.pesRadioChange.emit(e.detail);
  }
  render() {
    return (h(Host, null, this.items.map((item) => {
      var _a, _b;
      return (h("pes-radio-button", { onButtonChange: (e) => this.onChange(e), value: item.value, text: item.text, name: this.groupId, checked: ((_a = this.selectedValue) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = item.value) === null || _b === void 0 ? void 0 : _b.toString()) }));
    })));
  }
};
PesRadio.style = pesRadioCss;

const pesRadioButtonCss = ":host{white-space:nowrap}";

const PesRadioGroup = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.buttonChange = createEvent(this, "buttonChange", 1);
    this.value = undefined;
    this.text = undefined;
    this.name = undefined;
    this.checked = false;
  }
  onChange() {
    this.buttonChange.emit(this.value);
  }
  get id() {
    return `pes-radio-button-${this.name}-${this.value}`;
  }
  render() {
    return (h(Host, null, h("input", { onChange: () => this.onChange(), type: "radio", id: this.id, name: this.name, value: this.value, checked: this.checked }), h("label", { htmlFor: this.id }, this.text)));
  }
};
PesRadioGroup.style = pesRadioButtonCss;

export { PesRadio as pes_radio, PesRadioGroup as pes_radio_button };
